module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "fadeIn",
    attrs: {
      "id": "formContent"
    }
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('h2', {
    staticClass: "inactive"
  }, [_vm._v("Log In")])]), _vm._v(" "), _c('h2', {
    staticClass: "active"
  }, [_vm._v("Inquiry")])], 1), _vm._v(" "), _c('form', {
    staticClass: "formInit",
    attrs: {
      "id": "inquiryForm"
    }
  }, [_c('div', {
    staticClass: "wrap-input1 validate-input",
    attrs: {
      "data-validate": "Name is required"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "fadeIn ",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shadow-input1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-input1 validate-input",
    attrs: {
      "data-validate": "Valid email is required: ex@abc.xyz"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input1",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shadow-input1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-input1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company),
      expression: "company"
    }],
    staticClass: "input1",
    attrs: {
      "type": "text",
      "placeholder": "Company name"
    },
    domProps: {
      "value": (_vm.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shadow-input1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-input1 validate-input",
    attrs: {
      "data-validate": "Phone number is required: 9800xxx"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "input1",
    attrs: {
      "type": "text",
      "placeholder": "Phone number"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shadow-input1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-input1 validate-input",
    attrs: {
      "data-validate": "Subject is required"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    staticClass: "input1",
    attrs: {
      "type": "text",
      "placeholder": "Subject"
    },
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shadow-input1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap-input1 validate-input",
    attrs: {
      "data-validate": "Message is required"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "input1",
    attrs: {
      "placeholder": "Message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shadow-input1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "container-contact1-form-btn"
  }, [_c('button', {
    staticClass: "btnItm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendInquiry.apply(null, arguments)
      }
    }
  }, [_c('span', [_vm._v("\n                          Send\n                          ")])])])]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "formFooter"
    }
  }, [_c('span', {
    staticClass: "underlineHover"
  }, [_vm._v("Powered by")]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "https://raisetech.com.np",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/img/raiseTechlogo.png",
      "alt": "Raiselogo"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6723130"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inquiry.vue
// module id = 2439
// module chunks = 0